import { useTranslation } from 'react-i18next';
import { MainLayout } from '../../Layout/MainLayout';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useCustomerQuery } from '../../../api/customers';
import { useBoolean } from 'usehooks-ts';
import { UpdatePasswordForm } from './UpdatePasswordForm';
import { UpdatedView } from './UpdatedView';

export function UpdatePasswordPage() {
  const { t } = useTranslation();
  const customerQuery = useCustomerQuery();
  const identity = customerQuery.data?.identity;
  const changedFlag = useBoolean(false);

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={identity?.hasPassword ? t('Change password') : t('Set password')}
          parent={{
            to: '/account/settings',
            title: t('Settings'),
          }}
        />
      }
      compact
    >
      {identity ? (
        changedFlag.value ? (
          <UpdatedView text={t('Password successfully changed')} />
        ) : (
          <UpdatePasswordForm identity={identity} onComplete={changedFlag.setTrue} />
        )
      ) : null}
      {/* <Grid item xs={12}>
        <Stepper activeStep={step} sx={{ width: '100%' }} alternativeLabel>
          <Step>
            <BrightyStepButton>{t('Current password')}</BrightyStepButton>
          </Step>
          <Step>
            <BrightyStepButton>{t('New password')}</BrightyStepButton>
          </Step>
        </Stepper>
      </Grid> */}
    </MainLayout>
  );
}
